import filter from 'lodash/filter'
import groupBy from 'lodash/groupBy'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import toString from 'lodash/toString'
import str_is from 'str-is'

export default
{
	data()
	{
		return {
			notificationMethods: null,
		}
	},

	created()
	{
		this.fetchNotificationMethods()
	},

	computed:
	{
		hasNotificationMethods()
		{
			return !isEmpty(this.notificationMethods)
		},

		groupedNotificationMethods()
		{
			return map(groupBy(this.notificationMethods, 'type'), (options,label) => ({ label, options: options.filter(option => !isEmpty(option?.value)) }))
		},

		groupedEmailNotificationMethods()
		{
			return filter
			(
				this.groupedNotificationMethods,
				({ label, options }) => str_is('*email*', toString(label).toLowerCase())
			)
		},
	},

	methods:
	{
		fetchNotificationMethods()
		{
			return this.$http.get('/api/notification-methods')
				.then(response => this.notificationMethods = response.data && response.data.data)
				.catch(this.catchError)
		},

		valueOfNotificationMethod(id)
		{
			return this.notificationMethods
				?.find(option => id === option?.id)
				?.value
		},
	},
}